'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Created by ifchangetoclzp on 2016/11/11.
 */
exports.default = {
    easeOutFunction: 'cubic-bezier(0.23,1,0.32,1)',
    easeInOutFunction: 'cubic-bezier(0.445,0.05,0.55,0.95)',
    easeOut: function easeOut(duration, property, delay, easeFunction) {
        var _this = this;

        easeFunction = easeFunction || this.easeOutFunction;

        if (property && Object.prototype.toString.call(property) == '[object Array]') {
            return property.map(function (n) {
                return _this.create(duration, n, delay, easeFunction);
            }).join(',');
        } else {
            return this.create(duration, property, delay, easeFunction);
        }
    },
    create: function create(duration, property, delay, easeFunction) {
        duration = duration || '450ms';
        property = property || 'all';
        delay = delay || '0ms';
        easeFunction = easeFunction || 'linear';

        return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
    }
};


//////////////////
// WEBPACK FOOTER
// ../~/candy-mobile/lib/fn/transitions.js
// module id = ../node_modules/candy-mobile/lib/fn/transitions.js
// module chunks = 7